import lockIcon from "@ms/lock.svg?raw";
import publicIcon from "@ms/public.svg?raw";
import { Shimmer } from "@ui/Shimmer";
import { type Accessor, Match, Switch } from "solid-js";
import type { ListBoardItemResponse } from "@/client";
import { Icon } from "~/modules/shared/gvtui/Icon";
import { Pill } from "~/modules/shared/gvtui/Pill";
import { HStack } from "~/modules/shared/gvtui/Stack";

const mockBoard: ListBoardItemResponse = {
	id: "1",
	title: "Board 1",
	privacy: "private",
};

export const Title = (props: {
	board: Accessor<ListBoardItemResponse | undefined>;
}) => {
	return (
		<Switch>
			<Match when={!props.board()}>
				<div></div>
				<Shimmer mockData={mockBoard}>
					{(data) => <TitleContent board={data} />}
				</Shimmer>
			</Match>
			<Match when={props.board()}>
				<TitleContent board={props.board()} />
			</Match>
		</Switch>
	);
};

const TitleContent = (props: { board: ListBoardItemResponse }) => {
	return (
		<HStack align="center" spacing="large">
			<div>{`Board: ${props.board.title}`}</div>
			<Pill
				variant="filled"
				size="small"
				theme={props.board.privacy === "public" ? "success" : "grey200"}
			>
				{props.board.privacy === "public" ? (
					<Icon width="0.75rem" height="1rem" icon={publicIcon} />
				) : (
					<Icon width="0.75rem" height="1rem" icon={lockIcon} />
				)}
				{props.board.privacy === "public" ? "Public" : "Private"}
			</Pill>
		</HStack>
	);
};
